import { React, useState, useEffect } from "react";

const PopUpTeenpattiResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";

        const date = new Date(dateString);

        if (isNaN(date.getTime())) return "";

        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    let shownCard = "1";
    let PlayerA = "";
    let PlayerB = "";
    let PlayerAp = "";
    let PlayerBp = "";

    if (marketType == 17 || marketType == 25) {
        if (resultData?.result == 1) {
            PlayerA = "Winner";
            PlayerB = "LOSER";
        } else if (resultData?.result == 2) {
            PlayerA = "LOSER";
            PlayerB = "Winner";
        }

        PlayerAp = resultData?.isPair1 == 1 ? "Winner" : "LOSER";
        PlayerBp = resultData?.isPair2 == 1 ? "Winner" : "LOSER";
    }

    return (
      <div>
        <div id="ResultsData">
          <div class="left-content site_family">
            <div
              id="tp-20"
              style={{
                display: marketType == 17 || marketType == 25 ? "" : "none"
              }}
            >
              <div class="left-content">
                <div class="card">
                  <div class="card-header">
                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div
                        class="col-12 col-md-6"
                        style={{
                          margin: "auto",
                          textAlign: "left"
                        }}
                      >
                        <div class="player-item">
                          <b>
                            <span class="name" style={{ color: "#000" }}>
                              {resultData.cat_rnr1}
                            </span>
                          </b>
                          <div className="player-card">
                            <div
                              className="BFBCardHandViewDealerab"
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                width: "100%"
                              }}
                            >
                              <div
                                className="BFBCardFanViewab"
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  width: "100%"
                                }}
                              >
                                {[
                                  resultData.ac1,
                                  resultData.ac2,
                                  resultData.ac3
                                ].map((card, index) => (
                                  <div className="RSMImageView2ab" key={index}>
                                    <img
                                      style={{
                                        width: "100%",
                                        maxWidth: "50px",
                                        height: "auto"
                                      }}
                                      src={`/assets/images/cards/${card}.svg`}
                                      alt=""
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-12 col-md-6"
                        style={{
                          margin: "auto",
                          textAlign: "left"
                        }}
                      >
                        <div class="player-item">
                          <b>
                            <span class="name" style={{ color: "#000" }}>
                              {resultData.cat_rnr2}
                            </span>
                          </b>

                          <div className="player-card">
                            <div
                              className="BFBCardHandViewDealerab"
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                width: "100%"
                              }}
                            >
                              <div
                                className="BFBCardFanViewab"
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  width: "100%"
                                }}
                              >
                                {[
                                  resultData.bc1,
                                  resultData.bc2,
                                  resultData.bc3
                                ].map((card, index) => (
                                  <div className="RSMImageView2ab" key={index}>
                                    <img
                                      style={{
                                        width: "100%",
                                        maxWidth: "50px",
                                        height: "auto"
                                      }}
                                      src={`/assets/images/cards/${card}.svg`}
                                      alt=""
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="result-runners">
                        <div>
                          <div class="market-runners">
                            <div class="runner-runner">
                              <h3 class="runner-name">
                                <div class="runner-info">
                                  <span class="clippable runner-display-name">
                                    <h4
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      data-html="true"
                                      class="clippable-spacer"
                                    >
                                      {resultData.cat_rnr1}
                                    </h4>
                                  </span>
                                </div>
                              </h3>
                              <div class="runner-disabled">{PlayerA}</div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div class="market-runners">
                            <div class="runner-runner">
                              <h3 class="runner-name">
                                <div class="runner-info">
                                  <span class="clippable runner-display-name">
                                    <h4
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      data-html="true"
                                      class="clippable-spacer"
                                    >
                                      {resultData.cat_rnr2}
                                    </h4>
                                  </span>
                                </div>
                              </h3>
                              <div class="runner-disabled">{PlayerB}</div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div class="market-runners">
                            <div class="runner-runner">
                              <h3 class="runner-name">
                                <div class="runner-info">
                                  <span class="clippable runner-display-name">
                                    <h4
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      data-html="true"
                                      class="clippable-spacer"
                                    >
                                      {resultData.cat_rnr3}
                                    </h4>
                                  </span>
                                </div>
                              </h3>
                              <div class="runner-disabled">{PlayerAp}</div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div class="market-runners">
                            <div class="runner-runner">
                              <h3 class="runner-name">
                                <div class="runner-info">
                                  <span class="clippable runner-display-name">
                                    <h4
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      data-html="true"
                                      class="clippable-spacer"
                                    >
                                      {resultData.cat_rnr4}
                                    </h4>
                                  </span>
                                </div>
                              </h3>
                              <div class="runner-disabled">{PlayerBp}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <style>
          {`
    .result-runners {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .result-runners > div {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .result-runners .market-runners {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .result-runners .runner-runner {
        width: 100%;
        min-height: 65px;
        margin-top: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 2px;
    }

    .result-runners .runner-name {
        width: 100%;
        margin: 0;
        padding: 0;
        text-align: center;
    }

    .result-runners .runner-info {
        width: 100%;
        text-align: center;
    }

    .result-runners .runner-display-name {
        width: 100%;
        display: block;
        text-align: center;
    }

    .result-runners .clippable-spacer {
        width: 100%;
        margin: 0;
        padding: 0;
        text-align: center;
        font-size: 100px;
    }

    .result-runners .runner-disabled {
        width: 100%;
        line-height: 35px;
        margin: 0;
        padding: 0;
        color: #000;
        text-align: center;
        background: transparent;
        text-transform: uppercase;
        font-size: 15px;
    }

    .player-card {
        border: 1px solid rgba(255, 255, 255, 0.12);
        border-radius: 16px;
        padding: 2px 7px 2px;
        background: transparent;
        backdrop-filter: blur(1px);
        align-items: left;
    }
`}
        </style>
      </div>
    );
};

export default PopUpTeenpattiResults;

